export enum MediaType {
  banner = 'banner',
  video = 'video',
  // Outstream is only used for flooring
  outstream = 'outstream'
}
